import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import Text from '../../../../shared/Text'
import { FROM } from '../../../../../mappings/navigation'
import { Heading } from '@homebotapp/hb-react-component-catalog'

import styles from './CityCopy.module.scss'

const { NEW_HOME, RENTAL_PROPERTY, RENT_BUY, MARKET_TAB, SOLO_BUYER } = FROM

const FromPurchasePowerSubHead = () => (
  <FormattedMessage
    id='NewBuyerOnboarding.cityStep.subheadline.purchasePower'
    defaultMessage='To customize your experience, all we need is a little context on your goals with four easy questions:'
  />
)

const HEADLINE_MAP = {
  [SOLO_BUYER]: {
    Headline: (
      { welcomeBack, name } // eslint-disable-line
    ) =>
      welcomeBack ? (
        <FormattedMessage
          id='NewBuyerOnboarding.cityStep.headline.soloBuyerReturns'
          defaultMessage='Welcome Back {name}!'
          values={{ name }}
        />
      ) : (
        <FormattedMessage id='NewBuyerOnboarding.cityStep.headline.soloBuyer' defaultMessage='Ready to buy smart?' />
      ),
    SubHead: (
      { welcomeBack } // eslint-disable-line
    ) =>
      welcomeBack ? (
        <FormattedMessage
          id='NewBuyerOnboarding.cityStep.subheadline.soloBuyerReturns'
          defaultMessage='We’ve made some changes since you last visited. Providing a few more details can help customize your buying journey so you can build wealth without sacrificing the right home.'
        />
      ) : (
        <FormattedMessage
          id='NewBuyerOnboarding.cityStep.subheadline.soloBuyer'
          defaultMessage='Great! We believe you can build wealth without sacrificing the right home. A few more details can help customize your buying journey:'
        />
      )
  },
  [NEW_HOME]: {
    Headline: () => (
      <FormattedMessage id='NewBuyerOnboarding.cityStep.headline.dreamHome' defaultMessage='Find your dream home' />
    ),
    SubHead: FromPurchasePowerSubHead
  },
  [RENTAL_PROPERTY]: {
    Headline: () => (
      <FormattedMessage
        id='NewBuyerOnboarding.cityStep.headline.rentalProperty'
        defaultMessage='Find an investment property'
      />
    ),
    SubHead: FromPurchasePowerSubHead
  },
  [RENT_BUY]: {
    Headline: () => (
      <FormattedMessage
        id='NewBuyerOnboarding.cityStep.headline.rentBuy'
        defaultMessage='Rent your home and find a new one'
      />
    ),
    SubHead: FromPurchasePowerSubHead
  },
  [MARKET_TAB]: {
    Headline: () => (
      <FormattedMessage
        id='NewBuyerOnboarding.cityStep.headline.marketTab'
        defaultMessage='Are you ready to buy smart?'
      />
    ),
    SubHead: () => (
      <FormattedMessage
        id='NewBuyerOnboarding.cityStep.subheadline.marketTab'
        defaultMessage='Great! We believe you can build wealth without sacrificing the right home. To customize your experience, all we need is a little context on your goals with four easy questions:'
      />
    )
  }
}

export interface CityCopyProps {
  from: string
  name: string
  welcomeBack: boolean
}

export const CityCopy = ({ from, welcomeBack, name }: CityCopyProps) => {
  const { Headline, SubHead } = HEADLINE_MAP[from]

  return (
    <>
      <Heading size='md' mb={1}>
        <Headline welcomeBack={welcomeBack} name={name} />
      </Heading>
      <Text size='s' variant='neutralCool' variantCount='600' className={styles.subheadline}>
        <SubHead welcomeBack={welcomeBack} />
      </Text>
    </>
  )
}
